import { Variant } from 'components/ui/Button/Button';

export enum AppStatus {
  DRAFT = 'DRAFT',
  PENDING = 'PENDING',
  DECLINED = 'DECLINED',
  APPROVED = 'APPROVED',
  PUBLISHED = 'PUBLISHED',
  BLOCKED = 'BLOCKED',
}

export enum TooltipPositions {
  RIGHT = 'right',
  LEFT = 'left',
}

export enum DeveloperAppVerb {
  REQUEST_APPROVAL = 'REQUEST_APPROVAL',
  CANCEL_APPROVAL = 'CANCEL_APPROVAL',
  PUBLISH = 'PUBLISH',
  PENDING = 'PENDING',
  UNPUBLISH = 'UNPUBLISH',
}

export interface ITooltipFields {
  title: string;
  text: string;
  confirmText: string;
  buttonText: string;
}

export interface ISubmitButtonFields {
  buttonText: string;
  variant?: Variant;
  icon?: string;
}

export interface IAppStatusButtonOptions {
  [key: string]: ITooltipFields;
}

export interface ISubmitButton {
  [key: string]: ISubmitButtonFields;
}

// if status of an app is missing here, then we don't show the section with the button at all
export const appStatusButtonOptions: IAppStatusButtonOptions = {
  [AppStatus.DRAFT]: {
    title: 'tooltip.appStatus.draft.title',
    confirmText: 'tooltip.appStatus.draft.confirmText',
    text: 'tooltip.appStatus.draft.text',
    buttonText: 'delete.app',
  },
  // [AppStatus.APPROVED]: {
  //   title: 'tooltip.appStatus.approved.title',
  //   confirmText: 'tooltip.appStatus.approved.confirmText',
  //   text: 'tooltip.appStatus.approved.text',
  //   buttonText: 'tooltip.appStatus.approved.buttonText',
  // },
  [AppStatus.PUBLISHED]: {
    title: 'tooltip.appStatus.published.title',
    confirmText: 'tooltip.appStatus.published.confirmText',
    text: 'tooltip.appStatus.published.text',
    buttonText: 'unpublish.from.app.marketplace',
  },
  [AppStatus.PENDING]: {
    title: 'tooltip.appStatus.pending.title',
    confirmText: 'tooltip.appStatus.pending.confirmText',
    text: 'tooltip.appStatus.pending.text',
    buttonText: 'tooltip.appStatus.pending.buttonText',
  },
  // [AppStatus.DECLINED]: {
  //   title: 'tooltip.appStatus.declined.title',
  //   confirmText: 'tooltip.appStatus.declined.confirmText',
  //   text: 'tooltip.appStatus.declined.text',
  //   buttonText: 'tooltip.appStatus.declined.buttonText',
  // },
};
